import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=3bd972ca"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd972ca')) {
      api.createRecord('3bd972ca', component.options)
    } else {
      api.reload('3bd972ca', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=3bd972ca", function () {
      api.rerender('3bd972ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Tabs.vue"
export default component.exports